module.exports = __webpack_public_path__ + "img/IMG_0140.957af4df.jpg";